export type EventsHubResourceState = 'loading' | 'empty' | 'error' | 'ready'

export type EventsHubCardStatus = 'live' | 'registered' | 'upcoming' | 'recording' | 'past'

export interface EventsHubImageFocalPoint {
  readonly x: number
  readonly y: number
}

export interface EventsHubCard {
  readonly id: string
  readonly title: string
  readonly imageUrl: string
  readonly dateLabel: string
  readonly locationLabel: string
  readonly attendanceLabel?: string
  readonly description?: string
  readonly status?: EventsHubCardStatus
  readonly isLive?: boolean
  readonly isRegistered?: boolean
  readonly imageFocalPoint?: EventsHubImageFocalPoint
  readonly timeLabel?: string
  readonly dateChip?: string
  readonly startAt?: string
  readonly endAt?: string
  readonly timeZone?: string
}

export interface EventDurationParts {
  readonly unit: 'day' | 'hour' | 'minute'
  readonly count: number
}

export type LiveProgressParts =
  | { readonly type: 'day'; readonly current: number; readonly total: number }
  | { readonly type: 'remaining'; readonly hours: number; readonly minutes: number }

export const isEventsHubCardLive = (event: EventsHubCard): boolean => event.isLive === true || event.status === 'live'

const clampUnit = (value: number): number => Math.min(1, Math.max(0, value))

export const toEventCoverObjectPosition = (focalPoint?: EventsHubImageFocalPoint): string | undefined => {
  if (!focalPoint || !Number.isFinite(focalPoint.x) || !Number.isFinite(focalPoint.y)) return undefined
  const toPercent = (value: number) => `${Number((clampUnit(value) * 100).toFixed(3))}%`
  return `${toPercent(focalPoint.x)} ${toPercent(focalPoint.y)}`
}

export type EventsHubListDensity = 'compact' | 'comfortable' | 'roomy'

export type EventsHubListTab = 'upcoming' | 'past'

export type EventsPageHeaderHeading = 'events' | 'live' | 'upcoming' | 'past'
